import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar21Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar21 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar21Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar21">
        <G id="Group">
          <Path
            id="background"
            d="M151.833 303.666c83.856 0 151.834-67.978 151.834-151.833S235.689 0 151.833 0C67.978 0 0 67.978 0 151.833s67.978 151.833 151.833 151.833Z"
            fill={c.background}
          />
          <Path
            id="skin"
            d="M216.621 138.154c0-42.251 6.665-78.34-32.012-78.34-69.832 0-75.623 26.564-75.623 68.808 0 1.962.095 3.94.278 5.91-1.247.064-2.582.31-4.028.763-6.728 2.113-8.396 12.94-3.725 24.18 4.671 11.24 13.917 18.651 20.653 16.538a7.02 7.02 0 0 0 .914-.365c.961 6.323-.763 21.551.063 27.771 2.931 21.932-20.121 41.37-20.121 41.37s33.975 50.719 76.401 48.296c28.843-1.644 3.615-43.538 3.615-43.538s-10.16-8.222-11.352-12.972c-1.183-4.75-.182-21.845-.182-21.845 29.264 9.429 44.11-18.993 48.122-48.328 3.01-22.004-3.011-21.305-3.011-28.256l.008.008Z"
            fill={c.skin}
          />
          <Path
            id="Vector"
            d="M137.892 119.201a.105.105 0 0 0 .072.191c1.954-.255 11.812-1.271 18.771-1.136 9.325.174 15.235 7.173 17.706 3.058 1.183-1.97.103-5.783-16.912-7.586-7.483-.794-12.996.874-19.637 5.473Z"
            fill="#000"
          />
          <Path
            id="Vector_2"
            opacity={0.75}
            d="M178.969 163.534c-.532 2.446 2.025 4.067 10.787 3.654 7.221-.342 9.548-4.973 8.126-5.632-1.414-.652-3.312 2.264-8.015 2.264-6.855 0-10.374-2.733-10.906-.286h.008Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_3"
            d="M174.369 141.992c-1.946-3.893-4.742-6.586-7.888-8.452-1.922-1.136-3.98-1.962-6.053-2.566-6.514-1.883-13.226-1.525-16.658-1.462-1.088.024-1.708 1.12-1.088 1.923l1.748 2.248c.278.357.73.556 1.215.524 1.581-.103 5.227-.143 9.501.024a4.556 4.556 0 0 0-.477 2.009c0 2.932 2.852 5.315 6.363 5.315 3.106 0 5.687-1.867 6.243-4.33 2.94 1.724 5.561 3.829 6.649 5.037.199.214.58-.008.453-.263l-.008-.007Z"
            fill="#000"
          />
          <Path
            id="Vector_4"
            d="M200.393 121.886c.738 1.064 2.843 2.875 4.528 1.668 2.494-2.526 6.164-4.512 11.986-4.671-.047-1.231-.119-2.462-.19-3.686-13.838.127-17.333 5.235-16.316 6.689h-.008Z"
            fill="#000"
          />
          <Path
            id="Vector_5"
            opacity={0.75}
            d="M140.72 200.463c-4.837-4.345-9.659-9.77-13.408-15.505 0 .381 2.287 22.869 23.679 39.01 9.04 6.824 13.806 8.905 20.376 10.883.452-5.989.135-20.105.135-20.105-.35.04-17.492-2.336-30.782-14.275v-.008Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_6"
            opacity={0.75}
            d="M163.502 178.087c.699.834 11.971 14.497 23.362 14.497 9.7 0 11.59-10.795 11.844-11.391-3.05 1.311-5.552 5.005-11.224 5.005-12.201 0-20.534-5.529-23.982-8.111Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_7"
            opacity={0.75}
            d="M191.639 176.14c-2.979 0-3.94 1.47-3.94 1.47s-3.79-1.796-6.959-1.796c-3.17 0-6.053 1.637-9.032 2.042-3.01.413-8.214-.095-8.214-.095s-.023.294 0 .325c3.44 2.145 11.55 3.75 23.752 3.75 5.671 0 8.404-.08 11.454-1.168l.016-.032s-4.099-4.488-7.077-4.488v-.008Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_8"
            d="M201.441 136.057a19.132 19.132 0 0 0-1.835 3.154c-.103.23.207.429.365.238.437-.524 1.184-1.247 2.106-2.025 1.008 1.501 2.875 2.526 5.028 2.526 3.225 0 5.838-2.256 5.838-5.045 0-.881-.286-1.707-.746-2.43 2.971.286 4.432 1.453 6.291 1.43.016-1.359.024-2.725.016-4.091-2.939.166-6.323-1.017-9.517.341-2.812 1.192-5.465 3.043-7.538 5.91l-.008-.008Z"
            fill="#000"
          />
          <Path
            id="Vector_9"
            d="M243.916 272.544c-2.479-2.836-5.013-5.458-7.539-7.65-10.89-18.246-39.622-21.734-60.196-21.702 3.185 3.4 6.847 6.363 6.847 6.363s22.179 36.826 1.176 42.776a21.207 21.207 0 0 1-3.479.651c-.422.048-.858.08-1.311.104a49.59 49.59 0 0 1-2.407.071h-.572c-.794 0-1.589-.016-2.375-.048h-.056a56.618 56.618 0 0 1-2.343-.166l-.493-.048a57.222 57.222 0 0 1-2.383-.286h-.016a59.082 59.082 0 0 1-2.375-.397l-.373-.072a56.73 56.73 0 0 1-4.774-1.136c-.087-.023-.167-.047-.254-.071a74.09 74.09 0 0 1-2.383-.723c-28.264-9.222-49.743-37.247-54.565-43.96-4.043-.031-19.914 2.32-26.158 2.193-15.561-.318-27.421 2.677-36.453 7.626 27.683 29.303 66.893 47.597 110.384 47.597 34.626 0 66.543-11.597 92.09-31.114l.008-.008Z"
            fill="#000"
          />
          <Path
            id="hair"
            d="m223.85 109.176 3.129 1.375s-8.126-70.571-69.442-70.571c-61.317 0-75.226 20.32-85.973 43.705-12.464 27.112-11.288 51.078-21.591 91.772-7.054 27.858-12.964 55.16-14.076 74.4a153.749 153.749 0 0 0 10.962 11.669c6.585-5.6 17.206-10.938 43.435-13.949 6.204-.715 9.708-1.35 13.751-1.319 3.13.024 6.577.445 11.852 1.549 11.979 2.503 14.934 10.605 10.167-22.448-1.445-10.041-2.335-23.807-2.82-38.177-.127-3.805-.23-7.65-.301-11.47-.572-29.312.365-57.671 1.541-59.045 1.906-2.224 9.103-6.593 12.32-12.344 3.225-5.76 7.531-15.434 7.531-15.434s-2.995 19.104-7.134 21.868c9.922.747 25.896-2.709 25.896-2.709s9.62-4.663 10.859-30.558c.238-4.973 4.02 15.863 2.065 29.78-1.112 2.558 3.504-2.01 3.742-6.252.087-1.557.707-14.878.707-14.878l1.843 21.63 13.758.278 2.073-20.685 5.783 20.558s10.001 0 11.336 1.335c1.334 1.334 1.048 15.347.294 19.906-.763 4.56-1.335 10.263 0 13.687 1.334 3.424 4.941 18.636.953 27.572-3.996 8.937-19.962 41.259-23.005 43.539-2.438 1.827-11.637 2.82-17.952 1.875-1.573-.239-2.971-.588-4.036-1.081 0 0-1 17.095.183 21.845 1.184 4.75 11.352 12.972 11.352 12.972s22.178 36.826 1.175 42.776c-.04.206-.063.31-.063.31s30.535-2.876 37.438-10.589c6.903-7.713 10.874-23.839 11.073-32.569.207-8.73.421-24.212.421-24.212s2.447 14.712 2.097 23.688c-.286 7.443-2.621 19.708-2.621 19.708s6.871-2.192 7.379-19.422c.199-6.768-5.155-38.105-6.498-55.891-1.35-17.786-9.579-84.178-9.579-84.178l-.024-.016Z"
            fill={c.hair}
          />
        </G>
      </G>
    </Svg>
  );
};
